import { toEventPayload, normalizeIncludeInReports } from 'application/util/event-report.util';

export default class TransferService {
    /* @ngInject */
    constructor(apiService) {
        this.apiService = apiService;
    }

    create(calendarId, event) {
        return this.apiService.post(`/calendars/${calendarId}/transactions/transfers`, toEventPayload(event, false)).then((result) => normalizeIncludeInReports(result.data));
    }
}



// WEBPACK FOOTER //
// ./src/application/service/calendar/transaction/transfer.service.js